// Import database client
import databaseClient from '../databaseClient';

// Images storage name
const IMAGE_STORAGE = process.env.REACT_APP_DATABASE_IMAGE_STORAGE_PATH;

// Allowed image extensions and mime types (front-end guard; enforce again via bucket policies)
const ALLOWED_EXTENSIONS = ['.png', '.jpg', '.jpeg'];
const ALLOWED_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];

function getExtension(fileName) {
    const dot = fileName.lastIndexOf('.');
    return dot === -1 ? '' : fileName.substring(dot).toLowerCase();
}

function getContentType(fileName, file) {
    // Prefer the provided file type if valid, else infer from extension
    if (file?.type && ALLOWED_MIME_TYPES.includes(file.type)) return file.type;
    const ext = getExtension(fileName);
    if (ext === '.png') return 'image/png';
    if (ext === '.jpg' || ext === '.jpeg') return 'image/jpeg';
    return 'application/octet-stream';
}

// Get a signed url for a given image
export async function getProductImageSignedUrl(imagePath, timeout) {
    const { data, error } = await databaseClient.storage
        .from(IMAGE_STORAGE)
        .createSignedUrl(imagePath, timeout);

    // If there is an throw it
    if (error) {
        throw error;
    }

    return data.signedUrl;
}

// Add an image to the images bucket
export async function addImageToBucket(fileName, file) {
    // Front-end validation for extension and mime-type (defense-in-depth)
    const ext = getExtension(fileName);
    if (!ALLOWED_EXTENSIONS.includes(ext)) {
        throw new Error('Invalid image extension. Allowed: .png, .jpg, .jpeg');
    }
    if (file?.type && !ALLOWED_MIME_TYPES.includes(file.type)) {
        throw new Error('Invalid image content type');
    }

    const contentType = getContentType(fileName, file);

    const { error } = await databaseClient.storage
        .from(IMAGE_STORAGE)
        .upload(fileName, file, {
            upsert: false,
            contentType,
        });

    // If there is an throw it
    if (error) {
        throw error;
    }
}

// Delete an image from the images bucket
export async function deleteImageFromBucket(imagePath) {
    const { error } = await databaseClient.storage
        .from(IMAGE_STORAGE)
        .remove([imagePath]);

    // If there is an throw it
    if (error) {
        throw error;
    }
}
